import React, { ReactElement, useState } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import {
  Button, FormGroup, Label, Loader, LoaderButton, Select,
} from 'idsk-react-components';
import { useLocation, useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import Layout from '../../Layout';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import SecuredPage from '../../../module/SecuredPage';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import {
  useLegislativnyMaterialDetail,
} from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail';
import PracovnyKrokEnum from '../../../model/pracovnyKrok/PracovnyKrokEnum';
import { ObalMaterialuEnum } from '../../../constants/ObalMaterialuEnum';
import isPredbeznaInformacia from '../../../function/isPredbeznaInformacia';
import './obalMaterialuSelectPage.scss';
import SuccessMessages from '../../../module/SuccessMessages';
import { StadiumMaterialuEnum } from '../../../model/legislativnyMaterial/StadiumMaterialu';

const ObalMaterialuSelectPage = (): ReactElement => {
  const {
    type,
    year: yearParam,
    index: indexParam,
    stadiumUuid,
    stadium,
  } = useParams();

  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail(PracovnyKrokEnum.SPRIEVODNY_DOKUMENT_FUNCTION);
  const year = parseInt(yearParam, 10);
  const index = parseInt(indexParam, 10);
  const location = useLocation();
  const [selectedType, setSelectedType] = useState<ObalMaterialuEnum>(ObalMaterialuEnum.VSEOBECNY);
  const navigate = useNavigate();

  const onSubmit = (): void => {
    switch (selectedType) {
      case ObalMaterialuEnum.VSEOBECNY:
        navigate(
          routes.procesy.detail.sprievodneDokumenty.obalMaterialu.vseobecny.create
            .withParams(type, year, index, stadiumUuid, StadiumMaterialuEnum[stadium]),
        );
        break;
      case ObalMaterialuEnum.NR_SR:
        navigate(routes.procesy.detail.sprievodneDokumenty.obalMaterialu.obalNrSr.create
          .withParams(type, year, index, stadiumUuid));
        break;
      default:
        break;
    }
  };

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia(type) ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia(type) ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Sprievodná dokumentácia',
          to: routes.procesy.detail.sprievodneDokumenty.edit.withParams(type, year, index),
        },
        {
          heading: 'Voľba typu formulára',
          to: location.pathname,
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          hasOpravneniePracovneKroky={materialDetail?.hasOpravnenieSprievodneDokumenty}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
              <>
                <PageHeadingWithBackButton
                  headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                  heading="Voľba typu formulára obalu materiálu"
                />
                <Label htmlFor="typObaluMaterialu">
                  Typ formulára obalu materiálu
                </Label>
                <Select
                  className="obal-materialu__select"
                  id="typObaluMaterialu"
                  width="one-half"
                  name="typObaluMaterialu"
                  value={selectedType}
                  onChange={({ target }) => setSelectedType(target.value)}
                >
                  {Object.values(ObalMaterialuEnum).map(typ => (
                    <option
                      key={typ}
                      value={typ}
                    >
                      {typ}
                    </option>
                  ))}
                </Select>
                <FormGroup className="form-buttons">
                  <LoaderButton
                    type="submit"
                    size="large"
                    onClick={onSubmit}
                  >Zobraziť formulár
                  </LoaderButton>
                  <Button
                    className="obal_materialu__buttons"
                    type="button"
                    buttonStyle="third"
                    size="large"
                    onClick={() => {
                      navigate(routes.procesy.detail.sprievodneDokumenty.edit.withParams(type, year, index));
                    }}
                  >Späť
                  </Button>
                </FormGroup>
              </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default ObalMaterialuSelectPage;
